import EnterpriseDashboard from './enterprise_dashboard';

export { EnterpriseDashboard };
